<script>
import { mapGetters, mapActions } from 'vuex';
import { useAlert } from 'dashboard/composables';
import DeleteConfirmationModal from "../../branches/components/deleteConfirmationModal.vue";
import ReassignStaffModal from "./reassignStaffModal.vue"
import UpdateStatusModal from './updateStatusModal.vue';
import RescheduleModal from './rescheduleModal.vue';
import EditStaffNotesModal from './editStaffNotesModal.vue';
import UpdateReminderModal from './updateReminderModal.vue';
import StatusDropdown from './statusDropdown.vue';
import AoikumoSyncBadge from 'dashboard/components/dahreply/AoikumoSyncBadge.vue';

  export default{
    props:{
      contact: {
        type: Object,
      },
      status: {
        type: String,
        default: 'Status'
      },
      appointment_id: {
        type: String,
        default: '1234567890-qwer'
      }, 
      date: {
        type: String,
      },
      start_time: {
        type: String,
      },
      end_time: {
        type: String,
      },
      service: {
        type: Object,
      }, 
      created_by: {
        type: String,
        default: 'MintyGreen'
      },
      location: {
        type: String,
        default: 'Sungai Long, Kajang'
      },
      staff: {
        type: Object,
      },
      client_time_info: {
        type:Object
      },
      staff_notes: {
        type: String,
        default: 'There are no notes for this appointment.'
      },
      timezone: {
        type:String
      },
      before_reschedule_metadata: {
        type: Object
      },
      custom_metadata: {
        type: Object,
        default: null,
      },
      branch:{
        type: Object
      },
      reminders: {
        type: Array,
        default: () => [24, 1, 0.25] // 24 hours, 1 hour, and 15 minutes
      },
    },
    computed: {
      ...mapGetters('appointments', ['selectedBranch']),
      isServiceDeleted() {
        return this.service?.is_deleted || false;
      },
      hasClientLocalTime() {
        const clientTz = this.client_time_info?.client_timezone;
        return !!clientTz && clientTz !== this.timezone && !!this.client_time_info?.date;
      },
    },
    components: {
      ReassignStaffModal,
      DeleteConfirmationModal,
      UpdateStatusModal,
      RescheduleModal,
      EditStaffNotesModal,
      UpdateReminderModal,
      StatusDropdown,
      AoikumoSyncBadge,
    },
    data(){
      return{
        isReassignStaff: false,
        deleteObject: null,
        isUpdateStatus: false,
        isReschedule: false,
        branch: null,
        isEditStaffNote: false,
        isEditReminder: false,
        isStatusDropdownOpen: false,
      }
    },
    methods:{
      ...mapActions('appointments', [
        // 'deleteAppointment', 
        'fetchAppointments', 
        'updateAppointmentStatus', 
        'updateFilters'
      ]),
      ...mapActions('appointmentsV2', ['deleteAppointment']),
      resetModal(){
        this.isReassignStaff = false;
        this.isEditStaffNote = false;
        this.isEditReminder = false;
      },
      async handleDeleteAppointment(id){
        try{
          await this.deleteAppointment({ accountId: this.$store.getters['getCurrentAccountId'], appointmentId: id });
        }catch(err){
          console.error(err);
          useAlert(err);
        }finally{ 
          this.$emit('refreshDetails');
          this.deleteObject = null;
        }
      },
      formatReminderTime(hours) {
        if (hours >= 24) {
          const days = Math.floor(hours / 24);
          return `${days} ${days === 1 ? 'day' : 'days'} prior`;
        } else if (hours >= 1) {
          return `${hours} ${hours === 1 ? 'hour' : 'hours'} prior`;
        } else {
          const minutes = Math.round(hours * 60);
          return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} prior`;
        }
      },
      formatClientTime(time) {
        return time ? time.slice(0, 5) : '';
      },
      async handleUpdateStatus(status){
        try{
          await this.updateAppointmentStatus({
            appointmentId: this.appointment_id,
            status: status
          });
          useAlert('Appointment status updated');
          await this.updateFilters({status: status});
          this.$emit('refreshDetails');
        }catch(err){
          console.error(err);
          useAlert(err);
        }
      }
    },
    emits: ["refreshDetails"],
  }
</script>

<template>
  <div data-testid="appointment_details" :data-id="appointment_id" class="w-full overflow-hidden p-4 sm:p-5 lg:p-6 bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-100 dark:border-slate-700 transition-all duration-300 ease-in-out">
    <!-- Modals -->
    <div
      v-if="isReassignStaff === true"
      class="fixed inset-0 flex items-center justify-center h-[100vh] w-[100vw] bg-slate-900/50 dark:bg-slate-800/50 z-50"
    >
      <ReassignStaffModal :serviceObject="service" :appointmentId="appointment_id" @resetModal="resetModal()" @refreshDetails="$emit('refreshDetails')"/>
    </div>

    <div
      v-if="isEditReminder === true"
      class="fixed inset-0 flex items-center justify-center h-[100vh] w-[100vw] bg-slate-900/50 dark:bg-slate-800/50 z-50"
    >
      <UpdateReminderModal @closeModal="resetModal()"/>
    </div>

    <div
      v-if="isEditStaffNote === true"
      class="fixed inset-0 flex items-center justify-center h-[100vh] w-[100vw] bg-slate-900/50 dark:bg-slate-800/50 z-50"
    >
      <EditStaffNotesModal :staff_notes="staff_notes" :appointmentId="appointment_id" @resetModal="isEditStaffNote = false" @refreshDetails="$emit('refreshDetails')"/>
    </div>

    <div
      v-if="deleteObject"
      class="fixed inset-0 flex items-center justify-center h-[100vh] w-[100vw] bg-slate-900/50 dark:bg-slate-800/50 z-50"
    >
      <DeleteConfirmationModal        
        :deleteName="deleteObject.name"
        @confirm-delete="handleDeleteAppointment(deleteObject.id)"
        @close="deleteObject = null"
      />
    </div>

    <div
      v-if="isReschedule"
      class="fixed inset-0 flex items-center justify-center h-[100vh] w-[100vw] bg-slate-900/50 dark:bg-slate-800/50 z-50"
    >
      <RescheduleModal        
        @closeModal="isReschedule = false" 
        :appointmentId="appointment_id"
        :service="service"
        :staff="staff"
        :branch="branch"
        :previousTime="start_time"
        :previousDate="date"
        :client_time_info="client_time_info"
        :timezone="timezone"
        @refreshDetails="$emit('refreshDetails')"
      />
    </div>

    <UpdateStatusModal 
      v-if="isUpdateStatus" 
      @closeModal="isUpdateStatus = false" 
      :status="status" 
      :appointmentId="appointment_id" 
      @refreshDetails="$emit('refreshDetails')"
    />

    <!-- Header Card with Contact Info and Status - More responsive to container width -->
    <div class="flex flex-col sm:flex-row gap-3 pb-4 sm:pb-5 border-b border-slate-100 dark:border-slate-700">
      <div class="flex items-center flex-wrap gap-3 sm:w-2/3">
        <!-- Contact Icon with Avatar Background - Scaled for different container sizes -->
        <div class="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-woot-50 dark:bg-woot-900/30 flex items-center justify-center flex-shrink-0">
          <fluent-icon icon="people" size="24" class="text-woot-600 dark:text-woot-400" />
        </div>

        <!-- Contact Info -->
        <div class="flex flex-col">
          <h2 data-testid="appointment_details_contact_name" class="text-base sm:text-lg font-bold mb-1 text-slate-800 dark:text-slate-200 truncate" :title="contact.name">
            {{ contact.name }}
          </h2>
          <div class="flex flex-wrap items-center gap-2 mb-1">
            <StatusDropdown :status="status" :appointmentId="appointment_id" />
            <span class="text-xs text-slate-500 dark:text-slate-400 truncate max-w-[120px]" :title="`ID: ${appointment_id}`">
              ID: {{ appointment_id }}
            </span>
          </div>
        </div>
      </div>

      <!-- Action Buttons Group - Optimized for different screen sizes -->
      <div class="flex flex-wrap gap-1.5 sm:ml-auto items-start mt-2 sm:mt-0">
        <!-- Constructive Actions - More compact layout -->
        <div class="flex flex-wrap gap-1.5">
          <woot-button
            variant="smooth"
            color-scheme="secondary"
            size="tiny"
            class="whitespace-nowrap"
            data-testid="appointment_status_button"
            @click="isUpdateStatus = true"
            aria-label="Update appointment status"
            icon="status"
          >
            <span class="truncate">{{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.STATUS_BUTTON') }}</span>
          </woot-button>

          <woot-button
            variant="smooth"
            color-scheme="primary"
            size="tiny"
            class="whitespace-nowrap"
            data-testid="appointment_reschedule_button"
            @click="isReschedule = true"
            aria-label="Reschedule this appointment"
            icon="calendar"
          >
            <span class="truncate">{{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.RESCHEDULE_BUTTON') }}</span>
          </woot-button>
          
          <woot-button
            data-testid="appointment_view_button"
            variant="smooth"
            color-scheme="primary"
            size="tiny"
            class="whitespace-nowrap"
            @click="$router.push(`appointment/${appointment_id}`)"
            aria-label="View full appointment details"
            icon="arrow-expand"
          >
            <span class="truncate">{{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.VIEW_BUTTON') }}</span>
          </woot-button>
        
          <!-- Destructive Actions - Repositioned for better spacing -->
          <!-- <woot-button
            variant="smooth"
            color-scheme="alert"
            size="tiny"
            class="whitespace-nowrap"
            @click="deleteObject = { name: `${contact.name}'s appointment`, id: appointment_id }"
            aria-label="Delete this appointment"
            icon="delete"
          >
            <span class="truncate">Delete</span>
          </woot-button> -->
          
          <woot-button
            data-testid="appointment_cancel_button"
            variant="smooth"
            color-scheme="alert"
            size="tiny"
            class="whitespace-nowrap"
            @click="handleUpdateStatus('cancelled')"
            aria-label="Cancel this appointment"
            icon="dismiss"
          >
            <span class="truncate">{{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.CANCEL_BUTTON') }}</span>
          </woot-button>

          <woot-button
            v-if="status == 'requested'"
            data-testid="appointment_confirm_button"
            variant="smooth"
            color-scheme="primary"
            class="whitespace-nowrap"
            aria-label="Confirm this appointment"
            icon="checkmark-circle"
            @click="handleUpdateStatus('confirmed')"
          >
            <span class="truncate">{{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.CONFIRM_BUTTON') }}</span>
          </woot-button>
        </div>
      </div>
    </div>

    <!-- Appointment Details Section - Responsive grid for various containers -->
    <div class="my-4 sm:my-5">
      <h3 class="text-base sm:text-lg font-bold mb-3 text-slate-800 dark:text-slate-200 border-b border-slate-100 dark:border-slate-700 pb-2">
        {{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.TITLE') }}
      </h3>
      
      <!-- Grid optimized for different container widths -->
      <div class="grid grid-cols-1 gap-3">
        <!-- Date and Time Information - Optimized card for smaller spaces -->
        <div class="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-lg border border-slate-100 dark:border-slate-700">
          <div class="flex items-start mb-1.5">
            <fluent-icon icon="calendar" size="16" class="text-woot-600 dark:text-woot-400 mr-1.5 mt-0.5 flex-shrink-0" />
            <h4 class="font-semibold text-sm text-slate-700 dark:text-slate-300 truncate">
              {{ before_reschedule_metadata ? $t('APPOINTMENTS.APPOINTMENT_DETAILS.CURRENT_SCHEDULE') : $t('APPOINTMENTS.APPOINTMENT_DETAILS.DATE_AND_TIME') }}
            </h4>
          </div>
          <p data-testid="appointment_details_datetime" class="text-sm text-slate-600 dark:text-slate-400 ml-6 truncate" :title="`${date}, ${start_time}`">
            {{ date }}, {{ start_time }}
          </p>
          <p
            v-if="hasClientLocalTime"
            data-testid="appointment_customer_local_time"
            class="text-xs text-slate-400 dark:text-slate-500 ml-6 mt-1 truncate"
            :title="`${$t('APPOINTMENTS.APPOINTMENT_DETAILS.CUSTOMER_LOCAL_TIME')}: ${client_time_info.date}, ${formatClientTime(client_time_info.start_time)} (${client_time_info.client_timezone})`"
          >
            {{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.CUSTOMER_LOCAL_TIME') }}: {{ client_time_info.date }}, {{ formatClientTime(client_time_info.start_time) }} ({{ client_time_info.client_timezone }})
          </p>
        </div>
        
        <!-- Original Schedule (if rescheduled) - Optimized for limited space -->
        <div v-if="before_reschedule_metadata" class="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-lg border border-slate-100 dark:border-slate-700">
          <div class="flex items-start mb-1.5">
            <fluent-icon icon="history" size="16" class="text-amber-600 dark:text-amber-400 mr-1.5 mt-0.5 flex-shrink-0" />
            <h4 class="font-semibold text-sm text-slate-700 dark:text-slate-300 truncate">
              {{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.ORIGINAL_SCHEDULE') }}
            </h4>
          </div>
          <p class="text-sm text-slate-600 dark:text-slate-400 ml-6 truncate" :title="`${before_reschedule_metadata.date}, ${before_reschedule_metadata.start_time}`">
            {{ before_reschedule_metadata.date }}, 
            {{ before_reschedule_metadata.start_time }}
          </p>
        </div>
        
        <!-- Service Information - Better text handling -->
        <div class="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-lg border border-slate-100 dark:border-slate-700">
          <div class="flex items-start mb-1.5">
            <fluent-icon icon="briefcase" size="16" class="text-woot-600 dark:text-woot-400 mr-1.5 mt-0.5 flex-shrink-0" />
            <h4 class="font-semibold text-sm text-slate-700 dark:text-slate-300 truncate">
              {{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.SERVICE') }}
            </h4>
          </div>
          <div class="flex items-center gap-2 ml-6 mb-4">
            <p data-testid="appointment_details_service" class="text-sm text-slate-600 dark:text-slate-400 truncate mb-0" :title="service.service_name">
              {{ service.service_name }}
            </p>
            <fluent-icon 
              v-if="isServiceDeleted"
              v-tooltip.top="'This service has been deleted'"
              icon="warning" 
              size="16"
              class="text-amber-500 dark:text-amber-400 flex-shrink-0"
            />
          </div>
        </div>
        
        <AoikumoSyncBadge :custom-metadata="custom_metadata" />

        <!-- Branch Information - Optimized for space -->
        <div class="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-lg border border-slate-100 dark:border-slate-700">
          <div class="flex items-start mb-1.5">
            <fluent-icon icon="building-bank" size="16" class="text-woot-600 dark:text-woot-400 mr-1.5 mt-0.5 flex-shrink-0" />
            <h4 class="font-semibold text-sm text-slate-700 dark:text-slate-300 truncate">
              {{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.BRANCH') }}
            </h4>
          </div>
          <p data-testid="appointment_details_branch" class="text-sm text-slate-600 dark:text-slate-400 ml-6 truncate" :title="branch.branch_name">
            {{ branch.branch_name }}
          </p>
        </div>
        
        <!-- Created By Information - Container aware sizing -->
        <div class="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-lg border border-slate-100 dark:border-slate-700">
          <div class="flex items-start mb-1.5">
            <fluent-icon icon="person-add" size="16" class="text-woot-600 dark:text-woot-400 mr-1.5 mt-0.5 flex-shrink-0" />
            <h4 class="font-semibold text-sm text-slate-700 dark:text-slate-300 truncate">
              {{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.CREATED_BY') }}
            </h4>
          </div>
          <p class="text-sm text-slate-600 dark:text-slate-400 ml-6 truncate" :title="created_by ? created_by : '-'">
            {{ created_by ? created_by : "-" }}
          </p>
        </div>

        <!-- Reminder section with improved layout and styling -->
        <!-- <div class="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-lg border border-slate-100 dark:border-slate-700">
          <div class="flex items-start justify-between mb-2">
            <div class="flex items-center gap-2">
              <div class="p-1.5 bg-woot-50 dark:bg-woot-900/30 rounded-full">
                <fluent-icon icon="alarm" size="14" class="text-woot-600 dark:text-woot-400" />
              </div>
              <div class="flex items-center gap-2">
                <h4 class="font-semibold text-sm text-slate-700 dark:text-slate-300">Reminders</h4>
                <div class="relative group">
                  <fluent-icon 
                    icon="info" 
                    size="12" 
                    class="text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-400 cursor-help transition-colors" 
                  />
                  <div class="absolute bottom-full right-0 mb-2 w-48 px-3 py-2 bg-slate-900 dark:bg-slate-800 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 shadow-lg">
                    <p>Automatic reminders will be sent at these intervals before the appointment.</p>
                  </div>
                </div>
              </div>
            </div>
            <woot-button
              variant="smooth"
              color-scheme="primary"
              size="tiny"
              class="whitespace-nowrap"
              @click="isEditReminder = true"
              aria-label="Edit reminders"
            >
              <fluent-icon icon="edit" size="14" class="mr-1 flex-shrink-0" />
              <span class="truncate">Edit</span>
            </woot-button>
          </div>
          <div class="flex flex-wrap gap-2 ml-11">
            <div 
              v-for="reminder in reminders" 
              :key="reminder"
              class="inline-flex items-center gap-1.5 px-2 py-1 bg-slate-100 dark:bg-slate-700/50 rounded text-xs font-medium text-slate-700 dark:text-slate-300"
            >
              <fluent-icon 
                :icon="
                  reminder >= 24 ? 'calendar-day' : 
                  reminder >= 1 ? 'clock' : 
                  'timer'
                " 
                size="12" 
                class="text-slate-500 dark:text-slate-400"
              />
              {{ formatReminderTime(reminder) }}
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- Staff Information Section - Better spacing and responsiveness -->
    <div class="my-4 sm:my-5 border-t border-slate-100 dark:border-slate-700 pt-4 sm:pt-5">
      <div class="flex flex-wrap justify-between items-center gap-2 mb-3">
        <h3 class="text-base sm:text-lg font-bold text-slate-800 dark:text-slate-200 flex items-center">
          <fluent-icon icon="person" size="16" class="inline-block mr-2 text-woot-600 dark:text-woot-400 flex-shrink-0" />
          <span class="truncate">{{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.ASSIGNED_STAFF') }}</span>
        </h3>
        <woot-button
          variant="smooth"
          color-scheme="primary"
          size="tiny"
          class="whitespace-nowrap"
          data-testid="appointment_assign_staff_button"
          @click="isReassignStaff = true"
          aria-label="Assign a new staff member"
        >
          <fluent-icon icon="person-add" size="14" class="mr-1 flex-shrink-0" />
          <span class="truncate">{{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.ASSIGN_STAFF_BUTTON') }}</span>
        </woot-button>
      </div>
      <div class="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-lg border border-slate-100 dark:border-slate-700">
        <div class="flex items-center gap-2">
          <div class="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center flex-shrink-0">
            <fluent-icon icon="person" size="16" class="text-slate-600 dark:text-slate-300" />
          </div>
          <div class="overflow-hidden">
            <p data-testid="appointment_details_staff" class="font-medium text-sm sm:text-base text-slate-800 dark:text-slate-200 truncate" :title="staff.staff_name">{{ staff.staff_name }}</p>
            <p v-if="staff.role" class="text-xs sm:text-sm text-slate-500 dark:text-slate-400 truncate" :title="staff.role">{{ staff.role }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Staff Notes Section - Optimized for different container sizes -->
    <div class="mt-4 sm:mt-5 border-t border-slate-100 dark:border-slate-700 pt-4 sm:pt-5">
      <div class="flex flex-wrap justify-between items-center gap-2 mb-3">
        <h3 class="text-base sm:text-lg font-bold text-slate-800 dark:text-slate-200 flex items-center">
          <fluent-icon icon="note" size="16" class="inline-block mr-2 text-woot-600 dark:text-woot-400 flex-shrink-0" />
          <span class="truncate">{{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.STAFF_NOTES') }}</span>
        </h3>
        <woot-button
          variant="smooth"
          color-scheme="primary"
          size="tiny"
          class="whitespace-nowrap"
          @click="isEditStaffNote = true"
          aria-label="Edit staff notes"
        >
          <fluent-icon icon="edit" size="14" class="mr-1 flex-shrink-0" />
          <span class="truncate">{{ $t('APPOINTMENTS.APPOINTMENT_DETAILS.EDIT_NOTES_BUTTON') }}</span>
        </woot-button>
      </div>
      <div class="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-lg border border-slate-100 dark:border-slate-700">
        <!-- Limit text height with ellipsis for long notes to avoid overflow -->
        <p class="text-sm text-slate-700 dark:text-slate-300 whitespace-pre-line max-h-24 overflow-y-auto">
          {{ staff_notes ? staff_notes : $t('APPOINTMENTS.APPOINTMENT_DETAILS.NO_NOTES') }}
        </p>
      </div>
    </div>
  </div>
</template>